class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    // Ignore programmatic clicks (e.g. hero slideshow autoplay advancing slides)
    if (!event.isTrusted) return;
    const parked = document.body.querySelector('.search-modal[data-pv-search-parked="1"]');
    const inModal = this.contains(event.target) || (parked && parked.contains(event.target));
    if (!inModal || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // Prefer parked modal (moved to body for z-index) when present
    requestAnimationFrame(() => {
      const focusRoot =
        document.body.querySelector('.search-modal[data-pv-search-parked="1"]') || this.detailsContainer;
      trapFocus(
        focusRoot.querySelector('[tabindex="-1"]'),
        focusRoot.querySelector('input:not([type="hidden"])')
      );
    });
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
